import PropTypes from 'prop-types';
import React from 'react';

import Analytics from '@module/analytics';
import I18n from '@module/i18n';
import Illustration from '@component/illustration';

const upsells = [
  'upsell_one',
  'upsell_two',
  'upsell_three',
  'upsell_four',
  'upsell_five',
];

function handleUpsellClick() {
  Analytics.trackSnowplowEvent({
    category: 'upsell',
    action: 'click_upsell_button',
    label: this.state.key,
    property: 'download_page',
  });
}

export default class Upsell extends React.Component {
  static propTypes = {
    onContinue: PropTypes.func,
  };

  state = {
    key: upsells[Math.floor(Math.random() * upsells.length)],
  };

  constructor(props) {
    super(props);

    // FIXME: why do we need to bind a callback function?
    this.onContinue = props.onContinue.bind(this);
  }

  componentDidMount() {
    Analytics.trackSnowplowEvent({
      category: 'upsell',
      action: 'show_page',
      label: this.state.key,
      property: 'download_page',
    });
  }

  // Render our view
  render() {
    const { key } = this.state;
    const linkOptions = {
      href: I18n.t(`transfer.${key}.href`),
      onClick: handleUpsellClick.bind(this),
    };

    // External links are external
    if (linkOptions['href'].match(/^https?/)) {
      linkOptions['rel'] = 'external';
    }

    return (
      <div className="transfer__window downloader">
        <div className="transfer__contents">
          <div className="downloader__upsell">
            <Illustration type={`transfer-${key}`} />
            <h2>{I18n.t(`transfer.${key}.title`)}</h2>
            <p>
              <a {...linkOptions}>{I18n.t(`transfer.${key}.text`)}</a>
            </p>
          </div>
        </div>
        <div className="transfer__footer">
          <button onClick={this.onContinue} className="transfer__button">
            {I18n.t('transfer.buttons.continue')}
          </button>
        </div>
      </div>
    );
  }
}
